/* Library */
import React, { Component } from 'react';
import Link from '../../../../../components/ZUILib/Link';
import ApplyCSS from '../../../../../components/ApplyCSS';

const pageName = 'myWallets';

class MisMonederos extends Component {

  render() {
    const linkJSON = {
      displayName: 'Ir a mi cuenta Liverpool',
      children: 'Ir a mi cuenta Liverpool',
      areaLabel: 'abc',
      href: '/tienda/users/myAccount',
      tabindex: -1,
      cssClass: 'primaryColorLink',
      // isNotSamePage: true,
    };

    const ecommerceSite = 'https://www.liverpool.com.mx';

    linkJSON.href = ecommerceSite + linkJSON.href;

    return (
      <div className="col-md-12 oppeningContainer">
        <ApplyCSS pageName={pageName} />
        <h1 className="titleSection">Mis monederos</h1>
        <h2 className="subtitleModule"> La consulta de saldo y detalles de tu monedero puedes consultarlo dentro de la seccion de mi cuenta de Liverpool</h2>
        <Link linkJSON={linkJSON} >
          {linkJSON.displayName}<i className="icon-flecha_lightsvg_derecha" /></Link>
      </div>
    );
  }
}

export default MisMonederos;

